import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import categories from './categories'
/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/optionals'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/dashboard/optionals',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/optionals'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/optionals'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/optionals'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/optionals'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/optionals'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/optionals'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\OptionalController::store
* @see app/Http/Controllers/Admin/OptionalController.php:111
* @route '/dashboard/optionals'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/dashboard/optionals',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\OptionalController::store
* @see app/Http/Controllers/Admin/OptionalController.php:111
* @route '/dashboard/optionals'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\OptionalController::store
* @see app/Http/Controllers/Admin/OptionalController.php:111
* @route '/dashboard/optionals'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\OptionalController::store
* @see app/Http/Controllers/Admin/OptionalController.php:111
* @route '/dashboard/optionals'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\OptionalController::store
* @see app/Http/Controllers/Admin/OptionalController.php:111
* @route '/dashboard/optionals'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\OptionalController::update
* @see app/Http/Controllers/Admin/OptionalController.php:146
* @route '/dashboard/optionals/{optional}'
*/
export const update = (args: { optional: string | number | { id: string | number } } | [optional: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/dashboard/optionals/{optional}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\OptionalController::update
* @see app/Http/Controllers/Admin/OptionalController.php:146
* @route '/dashboard/optionals/{optional}'
*/
update.url = (args: { optional: string | number | { id: string | number } } | [optional: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { optional: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { optional: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            optional: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        optional: typeof args.optional === 'object'
        ? args.optional.id
        : args.optional,
    }

    return update.definition.url
            .replace('{optional}', parsedArgs.optional.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\OptionalController::update
* @see app/Http/Controllers/Admin/OptionalController.php:146
* @route '/dashboard/optionals/{optional}'
*/
update.put = (args: { optional: string | number | { id: string | number } } | [optional: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\OptionalController::update
* @see app/Http/Controllers/Admin/OptionalController.php:146
* @route '/dashboard/optionals/{optional}'
*/
const updateForm = (args: { optional: string | number | { id: string | number } } | [optional: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\OptionalController::update
* @see app/Http/Controllers/Admin/OptionalController.php:146
* @route '/dashboard/optionals/{optional}'
*/
updateForm.put = (args: { optional: string | number | { id: string | number } } | [optional: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\OptionalController::destroy
* @see app/Http/Controllers/Admin/OptionalController.php:170
* @route '/dashboard/optionals/{optional}'
*/
export const destroy = (args: { optional: string | number | { id: string | number } } | [optional: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/dashboard/optionals/{optional}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\OptionalController::destroy
* @see app/Http/Controllers/Admin/OptionalController.php:170
* @route '/dashboard/optionals/{optional}'
*/
destroy.url = (args: { optional: string | number | { id: string | number } } | [optional: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { optional: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { optional: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            optional: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        optional: typeof args.optional === 'object'
        ? args.optional.id
        : args.optional,
    }

    return destroy.definition.url
            .replace('{optional}', parsedArgs.optional.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\OptionalController::destroy
* @see app/Http/Controllers/Admin/OptionalController.php:170
* @route '/dashboard/optionals/{optional}'
*/
destroy.delete = (args: { optional: string | number | { id: string | number } } | [optional: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\OptionalController::destroy
* @see app/Http/Controllers/Admin/OptionalController.php:170
* @route '/dashboard/optionals/{optional}'
*/
const destroyForm = (args: { optional: string | number | { id: string | number } } | [optional: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\OptionalController::destroy
* @see app/Http/Controllers/Admin/OptionalController.php:170
* @route '/dashboard/optionals/{optional}'
*/
destroyForm.delete = (args: { optional: string | number | { id: string | number } } | [optional: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const optionals = {
    index: Object.assign(index, index),
    categories: Object.assign(categories, categories),
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default optionals